import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-672e2f92")

_pushScopeId("data-v-672e2f92")
const _hoisted_1 = { class: "register-form-only" }
const _hoisted_2 = { class: "bold center" }
const _hoisted_3 = { class: "form mt3 flex flex-column" }
const _hoisted_4 = { class: "input-wrapper input-wrapper--flex" }
const _hoisted_5 = { for: "email" }
const _hoisted_6 = { class: "input-wrapper input-wrapper--flex" }
const _hoisted_7 = { for: "companyName" }
const _hoisted_8 = { class: "input-wrapper input-wrapper--flex" }
const _hoisted_9 = { class: "input-wrapper input-wrapper--flex" }
const _hoisted_10 = { for: "password" }
const _hoisted_11 = { class: "input-wrapper input-wrapper--flex" }
const _hoisted_12 = { for: "password" }
const _hoisted_13 = { class: "input-wrapper input-wrapper--flex" }
const _hoisted_14 = { for: "referralCode" }
const _hoisted_15 = {
  key: 0,
  class: "invoice"
}
const _hoisted_16 = { class: "input-wrapper input-wrapper--flex" }
const _hoisted_17 = { for: "companyAddress" }
const _hoisted_18 = { class: "input-wrapper input-wrapper--flex" }
const _hoisted_19 = { for: "zipCode" }
const _hoisted_20 = { class: "input-wrapper input-wrapper--flex" }
const _hoisted_21 = { for: "city" }
const _hoisted_22 = { class: "input-wrapper input-wrapper--flex" }
const _hoisted_23 = { for: "city" }
const _hoisted_24 = { class: "input-wrapper input-wrapper--flex" }
const _hoisted_25 = { for: "taxId" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Input = _resolveComponent("Input")!
  const _component_DropdownSelect = _resolveComponent("DropdownSelect")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("p", _hoisted_2, _toDisplayString(_ctx.t('adminPanel.registerForm.getFreePackage')), 1),
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _createVNode("label", _hoisted_5, _toDisplayString(_ctx.t('auth.email')) + "*", 1),
        _createVNode(_component_Input, {
          modelValue: _ctx.email,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.email = $event)),
          id: "email",
          type: "text"
        }, null, 8, ["modelValue"])
      ]),
      _createVNode("div", _hoisted_6, [
        _createVNode("label", _hoisted_7, _toDisplayString(_ctx.t('auth.companyName')) + "*", 1),
        _createVNode(_component_Input, {
          modelValue: _ctx.companyName,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.companyName = $event)),
          id: "companyName",
          type: "text"
        }, null, 8, ["modelValue"])
      ]),
      _createVNode("div", _hoisted_8, [
        _createVNode("label", null, _toDisplayString(_ctx.t('auth.boardTemplate')) + "*", 1),
        _createVNode(_component_DropdownSelect, {
          modelValue: _ctx.boardTemplate,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.boardTemplate = $event)),
          options: _ctx.boardTemplates,
          "option-label": "label",
          "option-value": "value"
        }, null, 8, ["modelValue", "options"])
      ]),
      _createVNode("div", _hoisted_9, [
        _createVNode("label", _hoisted_10, _toDisplayString(_ctx.t('auth.password')) + "*", 1),
        _createVNode(_component_Input, {
          modelValue: _ctx.password,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.password = $event)),
          id: "password",
          type: "password"
        }, null, 8, ["modelValue"])
      ]),
      _createVNode("div", _hoisted_11, [
        _createVNode("label", _hoisted_12, _toDisplayString(_ctx.t('auth.confirmPassword')) + "*", 1),
        _createVNode(_component_Input, {
          modelValue: _ctx.confirmPassword,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.confirmPassword = $event)),
          id: "confirm-password",
          type: "password",
          onKeyup: _withKeys(_ctx.handleRegister, ["enter"])
        }, null, 8, ["modelValue", "onKeyup"])
      ]),
      _createVNode("div", _hoisted_13, [
        _createVNode("label", _hoisted_14, _toDisplayString(_ctx.t('auth.referralCode')), 1),
        _createVNode(_component_Input, {
          modelValue: _ctx.referralCode,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.referralCode = $event)),
          id: "referralCode",
          type: "text"
        }, null, 8, ["modelValue"])
      ]),
      (_ctx.invoiceDataOpen)
        ? (_openBlock(), _createBlock("div", _hoisted_15, [
            _createVNode("div", _hoisted_16, [
              _createVNode("label", _hoisted_17, _toDisplayString(_ctx.t('auth.companyAddress')) + "*", 1),
              _createVNode(_component_Input, {
                modelValue: _ctx.companyAddress,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.companyAddress = $event)),
                id: "companyAddress",
                type: "text"
              }, null, 8, ["modelValue"])
            ]),
            _createVNode("div", _hoisted_18, [
              _createVNode("label", _hoisted_19, _toDisplayString(_ctx.t('auth.zipCode')) + "*", 1),
              _createVNode(_component_Input, {
                modelValue: _ctx.zipCode,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.zipCode = $event)),
                id: "zipCode",
                type: "text"
              }, null, 8, ["modelValue"])
            ]),
            _createVNode("div", _hoisted_20, [
              _createVNode("label", _hoisted_21, _toDisplayString(_ctx.t('auth.city')) + "*", 1),
              _createVNode(_component_Input, {
                modelValue: _ctx.city,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.city = $event)),
                id: "city",
                type: "text"
              }, null, 8, ["modelValue"])
            ]),
            _createVNode("div", _hoisted_22, [
              _createVNode("label", _hoisted_23, _toDisplayString(_ctx.t('auth.country')) + "*", 1),
              _createVNode(_component_DropdownSelect, {
                modelValue: _ctx.country,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.country = $event)),
                options: _ctx.COUNTRIES,
                "option-label": "name",
                "option-value": "code"
              }, null, 8, ["modelValue", "options"])
            ]),
            _createVNode("div", _hoisted_24, [
              _createVNode("label", _hoisted_25, _toDisplayString(_ctx.t('auth.taxId')) + "*", 1),
              _createVNode(_component_Input, {
                modelValue: _ctx.taxId,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.taxId = $event)),
                id: "taxId",
                type: "text"
              }, null, 8, ["modelValue"])
            ])
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_Button, {
        class: "flex-auto",
        onClick: _ctx.handleRegister
      }, {
        default: _withId(() => [
          _createTextVNode(_toDisplayString(_ctx.loadingText ? _ctx.loadingText : _ctx.$t('auth.register')), 1)
        ]),
        _: 1
      }, 8, ["onClick"])
    ])
  ]))
})